import { render, staticRenderFns } from "./UserImageAvatar.vue?vue&type=template&id=c9914f74&scoped=true&"
import script from "./UserImageAvatar.vue?vue&type=script&lang=js&"
export * from "./UserImageAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9914f74",
  null
  
)

export default component.exports